import moment from 'moment';
import { jwtDecode } from 'jwt-decode';

export const getUniqueId = (parts = 2): string => {
  const stringArr = [];
  for (let i = 0; i < parts; i++) {
    const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    stringArr.push(S4);
  }
  return stringArr.join('_');
}

export const calculateAgeByDate = (date: Date | string) => {
  try {

    const dateBy = new Date(moment.utc((date)).local().toDate());
    const currentDate = new Date();
    const oneDay = 24 * 60 * 60 * 1000; // Milliseconds in a day
    const oneMin = 60 * 1000; // Milliseconds in a minute
    const diffInMilliseconds = currentDate.getTime() - dateBy.getTime();

    if (diffInMilliseconds > oneDay) {
      let days = Math.round(Math.abs(diffInMilliseconds / oneDay));
      const years = Math.floor(days / 365);
      days = years >= 1 ? (days - (365 * years)) : days;
      const months = Math.floor(days / 30);
      days = months >= 1 ? (days - (30 * months)) : days;
      const weeks = Math.floor(days / 7);
      days = weeks >= 1 ? (days - (7 * weeks)) : days;
      return `${years >= 1 ? years + 'y,' : ''} ${months >= 1 ? months + 'm,' : ''} ${weeks >= 1 ? weeks + 'w' : ''} ${days + 'd'}`;
    } else {
      let minutes = Math.round(Math.abs(diffInMilliseconds / oneMin));
      const hours = Math.floor(minutes / 60);
      minutes = hours >= 1 ? (minutes - (60 * hours)) : minutes;
      return `${hours >= 1 ? hours + 'h,' : ''} ${minutes >= 1 ? minutes + 'min' : 'now'}`;
    }
  } catch (err) {
    return `Not a date`;
  }
};

export const removeHTMLElement = (id: string) => {
  const elem: any = document.getElementById(id);
  return elem.parentNode.removeChild(elem);
}

export const getDecodedAccessToken = (token: string): any => {
  try {
    return jwtDecode(token);
  } catch (Error) {
    return null;
  }
}
